import styled from "styled-components";

export const Root = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.spacing_24};
  flex-direction: column;

  padding-top: ${props => props.theme.spacing.spacing_64};

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_128};
    gap: ${({ theme }) => theme.spacing.spacing_32};
  }

  ${({ theme }) => theme.breakpointsV2.smallDesktop} {
    padding-top: ${({ theme }) => theme.spacing.spacing_160};
  }
`;
